import React from 'react';
import Icon from '../AppIcon';
import { SocialLink } from '../../pages/home-landing/types';

interface FooterProps {
    socialLinks?: SocialLink[];
}

const Footer = ({ socialLinks = [] }: FooterProps) => {
    return (
        <footer className="py-20 border-t-2 border-[#0C2C39]/10 bg-transparent relative overflow-hidden">
            {/* Subtle Gradient Glow */}
            <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-teal-700/5 rounded-full blur-[120px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 relative z-10">
                <div className="flex flex-col md:flex-row items-center justify-between gap-12">
                    <div className="flex flex-col items-center md:items-start group">
                        <div className="flex items-center space-x-4 mb-3">
                            <div className="w-10 h-10 rounded-xl bg-[#0C2C39] flex items-center justify-center shadow-[3px_3px_0px_0px_rgba(13,148,136,0.3)] transition-transform group-hover:-rotate-3">
                                <span className="text-white font-black text-xs">YK</span>
                            </div>
                            <span className="text-xl font-black text-[#0C2C39] tracking-tighter  font-roboto">Yabets Kifle</span>
                        </div>
                        <p className="text-[10px] font-black  tracking-[0.3em] text-[#0C2C39]/30">
                            Systems Architect & Software Engineer
                        </p>
                    </div>

                    <div className="flex items-center space-x-10">
                        {socialLinks.map((link) => (
                            <a
                                key={link.id}
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#0C2C39]/40 hover:text-teal-700 transition-all hover:scale-110 active:scale-90"
                                aria-label={`Visit ${link.platform} profile`}
                            >
                                <Icon name={link.icon as any} size={20} />
                            </a>
                        ))}
                    </div>

                    <div className="flex flex-col items-center md:items-end gap-2">
                        <p className="text-[10px] font-black  tracking-[0.2em] text-[#0C2C39]/60">
                            © {new Date().getFullYear()} Precision Built.
                        </p>
                        <div className="flex items-center gap-2">
                            <div className="w-1.5 h-1.5 rounded-full bg-teal-700 animate-pulse" />
                            <span className="text-[8px] font-black  tracking-widest text-teal-700/50">Operational Status: Optimal</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
